import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from '@angular/http';
import { Response } from '@angular/http';
import { DatePipe } from '@angular/common';
import 'rxjs/add/operator/map';
import { Profession } from '../models';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class ProfessionService {


  private url = `/api/professions`;

  constructor(private http: HttpClient) { }

  public find(): Observable<[Profession]> {
    const params = new HttpParams()
      .set('size', 'page')
      .set('size', '50')
      .set('sortName', 'libelle')
      .set('sortType', 'ASC');
    return this.http.get <[Profession]>(this.url, { params: params });
  }

  /**
   * create a  new profession
   * @param profession
   */
  create(profession: Profession) {
    return this.http.post(this.url, profession)
      .map(
        (data) => {
          console.log(data);
        }
      );
  }
  /**
   * delete a new patient
   * @param profession
   */
  delete(profession: Profession) {
    return this.http.delete(`${this.url}/${profession.id}`)
      .map(
        (data) => {
          console.log(data);
        }
      );
  }
  /**
   * update a profession
   * @param profession
   */
  update(profession: Profession) {
    return this.http.put(`${this.url}/${profession.id}`, profession)
      .map(
        (data) => {
          console.log(data);
        }
      );
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/profession.service.ts